import {getMarkRange} from './getMarkRange';
import {TextSelection} from 'prosemirror-state';

export const moveCursorToEnd = dom => {
  dom.focus();
  if (typeof dom.selectionStart === 'number') {
    dom.selectionStart = dom.selectionEnd = dom.value.length;
  } else if (typeof dom.createTextRange != 'undefined') {
    dom.focus();
    const range = dom.createTextRange();
    range.collapse(false);
    range.select();
  }
};

export const findRange = (view, dom, type) => {
  const pos = view.posAtDOM(dom, 0);
  if (!pos) {
    return;
  }

  return getMarkRange(view.state.doc.resolve(pos), type);
};

export const handleClick = (view, dom, type) => {
  const range = findRange(view, dom, type);
  if (!range) {
    return;
  }

  view.dispatch(view.state.tr.setSelection(
      TextSelection.create(view.state.doc, range.from, range.to)).
  scrollIntoView());
};

export const handleDelete = (view, dom, type) => {
  const range = findRange(view, dom, type);
  if (!range) {
    return;
  }

  view.dispatch(
      view.state.tr.insertText('', range.from, range.to).scrollIntoView());
};